import React from "react";
import PropTypes from "prop-types";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./EventModalLoader.scss";

const EventModalLoader = ({ testId = "event-modal-loader" }) => {
  return (
    <div className={classes.loaderContainer} data-test-id={testId}>
      {/* Header section with badge and action icons */}
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <SkeletonLoader width="100%" height="20px" borderRadius="4px" />
        </div>
      </div>

      {/* Body section */}
      <div className={classes.body}>
        {/* Title */}
        <div className={classes.titleSection}>
          <SkeletonLoader width="180px" height="20px" borderRadius="4px" />
        </div>

        {/* Time section */}
        <div className={classes.timeFieldsSection}>
          <SkeletonLoader width="60px" height="20px" borderRadius="4px" />
          <div className={classes.timeFields}>
            <SkeletonLoader width="100%" height="20px" borderRadius="8px" />
          </div>
        </div>

        {/* Meeting link section */}
        <div className={classes.linkSection}>
          <div className={classes.linkHeader}>
            <SkeletonLoader width="110px" height="20px" borderRadius="4px" />
          </div>
          <SkeletonLoader width="320px" height="20px" borderRadius="4px" />
        </div>

        {/* Assigned to section */}
        <div className={classes.assignedSection}>
          <div className={classes.assignedHeader}>
            <SkeletonLoader width="100px" height="20px" borderRadius="4px" />
          </div>
          <SkeletonLoader width="280px" height="20px" borderRadius="4px" />
        </div>
      </div>

      {/* Footer section */}
      <div className={classes.footer}>
        <div className={classes.createdBy}>
          <SkeletonLoader width="36px" height="36px" borderRadius="50%" />
          <div className={classes.creatorInfo}>
            <SkeletonLoader width="80px" height="16px" borderRadius="4px" />
            <SkeletonLoader width="140px" height="18px" borderRadius="4px" />
          </div>
        </div>
        <SkeletonLoader width="140px" height="20px" borderRadius="8px" />
      </div>
    </div>
  );
};

EventModalLoader.propTypes = {
  testId: PropTypes.string,
};

export default EventModalLoader;
